import React, { FC, useContext } from 'react'
import styled from 'styled-components'
import { LoginContext } from '@providers/Login'
import { connect, useDispatch } from 'react-redux'
import { Container, Row, Col, Divider } from '@mch-group/uikit-components'
import { getPressAccData } from '@stores/pressAcc'
import { getSiteLanguage } from '@utils/storage'
import { useLabelsFromAPI } from '@dmi-mch/hooks'
import ProfileView from './ProfileView'
import ProfileForm from './ProfileForm'
import Loader from './Loader'
import CompleteMessage from './CompleteMessage'

const mID = 'press-accreditation-profile'

interface IProfile {
  className?: string
  mpapd_module_title: string
  mpapd_complete_profile: string
  mpapd_personal_lbl: string
  mpapd_edit_profile: string
  mpapd_name_and_surname_lbl: string
  mpapd_organization: string
  mpapd_function: string
  mpapd_media_type: string
  mpapd_contact_information: string
  mpapd_email: string
  mpapd_telephone: string
  mpapd_address: string
  mpapd_subscription_lbl: string
  mpapd_receiving_pp_by: string
  mpapd_no_information: string
  press: any
  getPressAccData: () => void
}

const ProfileComponent: FC<IProfile> = ({ press, ...props }) => {
  const dispatchPressData = useDispatch()
  const { labels } = useLabelsFromAPI(
    ['FieldValidation', 'PressAccreditation', 'UserAccountMessages'],
    getSiteLanguage()
  )
  const [isProfileOpen, setProfileOpen] = React.useState(false)

  React.useEffect(() => {
    const requestPressAccData = async () => {
      dispatchPressData(getPressAccData())
    }
    press?.data?.profile !== null && !press?.data && requestPressAccData()
  }, [dispatchPressData, press?.data])

  if (!press?.data?.profile) {
    return null
  }

  return press?.data ? (
    <div className={mID}>
      <Container className={`${props.className} px-5 px-lg-8 px-md-7 pb-5 pb-md-7 pb-xl-8`}>
        {/* title module */}
        <Divider color='mch-gray-200' size='m' className='mb-0' />
        <Row>
          <Col xs={12} md={6} className='profile-heading'>
            <h2 className='my-8 my-md-8 my-xl-9 h3'>{props?.mpapd_module_title}</h2>
          </Col>
        </Row>

        <Divider color='mch-gray-200' size='m' className='mb-8 mb-sm-8 mb-md-8 mb-lg-9 mb-xl-9' />

        {/* message module */}
        {!press?.validProfile && (
          <Row className='mt-0'>
            <Col
              md={12}
              lg={{ span: 11, offset: 1 }}
              xl={{ span: 10, offset: 1 }}
              className='mt-0 mb-7 mb-md-8 mb-xl-9'
            >
              <CompleteMessage mpapd_complete_profile={props.mpapd_complete_profile} />
            </Col>
          </Row>
        )}

        {/* view module */}
        {!isProfileOpen && (
          <ProfileView
            isProfileOpen={isProfileOpen}
            setProfileOpen={setProfileOpen}
            mID={mID}
            validProfile={press?.validProfile}
            mpapd_personal_lbl={props.mpapd_personal_lbl}
            mpapd_edit_profile={props.mpapd_edit_profile}
            mpapd_name_and_surname_lbl={props.mpapd_name_and_surname_lbl}
            mpapd_organization={props.mpapd_organization}
            mpapd_function={props.mpapd_function}
            mpapd_media_type={props.mpapd_media_type}
            mpapd_contact_information={props.mpapd_contact_information}
            mpapd_email={props.mpapd_email}
            mpapd_telephone={props.mpapd_telephone}
            mpapd_address={props.mpapd_address}
            mpapd_subscription_lbl={props.mpapd_subscription_lbl}
            mpapd_receiving_pp_by={props.mpapd_receiving_pp_by}
            mpapd_no_information={props.mpapd_no_information}
            profile={press?.data?.profile}
            countries={press?.data?.countries}
            mediaFunctions={press?.data?.mediaFunctions}
            mediaTypes={press?.data?.mediaTypes}
            salutations={press?.data?.salutations}
          />
        )}

        {/* edit module */}
        {isProfileOpen && (
          <ProfileForm
            setProfileOpen={setProfileOpen}
            isProfileOpen={isProfileOpen}
            profile={press?.data?.profile}
            countries={press?.data?.countries}
            mediaFunctions={press?.data?.mediaFunctions}
            mediaTypes={press?.data?.mediaTypes}
            salutations={press?.data?.salutations}
            props={props}

          />
        )}
      </Container>
    </div>
  ) : (
    <Loader label={labels?.PressAccreditation?.loaderMessage} />
  )
}

const Profile: FC<IProfile> = ({ press, ...props }) => {
  const { user } = useContext(LoginContext)
  return user?.me ? <ProfileComponent press={press} {...props} /> : null
}

const ProfileConnected = connect(
  ({ shared, press }) => ({
    store: shared?.globalModules?.validationMessageModule?.labels || null,
    press: press || null
  }),
  {
    getPressAccData
  }
)(Profile)

const StyledProfile = styled(ProfileConnected)`
  .edit-profile {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .img-square {
    width: 100%;
    background: var(--bs-mch-gray-100);
    aspect-ratio: 1/1; /* stylelint-disable-line property-no-unknown */
  }

  .form-check-label {
    display: flex;
    align-items: center;
  }

  .save-form .btn {
    min-width: 0;
    width: 100%;
  }
`

export default StyledProfile
